(function() {
  'use strict';

  var BLOCKED_PRODUCT_TOKENS = ['dyad', 'fusion', 'deep-v', 'atlas', 'chukker', 'major-tom'];
  var TUBELESS_OPTION_SELECTOR = '.gpo-element.gpo-form__group.gpo-col-12.show-addon-for-option';
  var TUBELESS_TEXT_REGEX = /\btubeless\s+valves?\b/i;
  var MACHINED_SIDEWALL_OPTION_SELECTOR = '.gpo-element.gpo-form__group, .gpo-element.gpo-form__group.gpo-col-12.show-addon-for-option';
  var MACHINED_SIDEWALL_TEXT_REGEX = /\bmachined\s+sidewalls?\b/i;
  var NON_MACHINED_SIDEWALL_TEXT_REGEX = /\bnon[-\s]?machined(?:\s+sidewalls?)?\b/i;
  var AILERON_TRACK_REQUIRED_TOKENS = ['aileron', 'track'];
  var AILERON_TRACK_WHEEL_TOKENS = ['wheelset', 'wheel'];

  function getCurrentPath() {
    if (!window.location || !window.location.pathname) return '';
    return window.location.pathname.toLowerCase();
  }

  function normalizeText(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function isBlockedProductPage() {
    var path = getCurrentPath();
    if (path.indexOf('/products/') === -1) return false;

    return BLOCKED_PRODUCT_TOKENS.some(function(token) {
      return path.indexOf(token) !== -1;
    });
  }

  function isAileronTrackWheelPage() {
    var path = getCurrentPath();
    if (path.indexOf('/products/') === -1) return false;

    var hasRequiredTokens = AILERON_TRACK_REQUIRED_TOKENS.every(function(token) {
      return path.indexOf(token) !== -1;
    });
    if (!hasRequiredTokens) return false;

    return AILERON_TRACK_WHEEL_TOKENS.some(function(token) {
      return path.indexOf(token) !== -1;
    });
  }

  function isMachinedChoiceText(text) {
    var normalized = normalizeText(text);
    return MACHINED_SIDEWALL_TEXT_REGEX.test(normalized) && !NON_MACHINED_SIDEWALL_TEXT_REGEX.test(normalized);
  }

  function isNonMachinedChoiceText(text) {
    return NON_MACHINED_SIDEWALL_TEXT_REGEX.test(normalizeText(text));
  }

  function dispatchFieldEvent(field, eventName) {
    if (!field || typeof Event !== 'function' || typeof field.dispatchEvent !== 'function') return;
    field.dispatchEvent(new Event(eventName, { bubbles: true }));
  }

  function triggerFieldUpdate(field) {
    dispatchFieldEvent(field, 'input');
    dispatchFieldEvent(field, 'change');
  }

  function hideOptionGroup(optionEl, hiddenFlag) {
    if (optionEl.dataset[hiddenFlag] === 'true') return;
    optionEl.style.display = 'none';
    optionEl.dataset[hiddenFlag] = 'true';
  }

  function getChoiceText(field) {
    if (field && field.parentNode) return normalizeText(field.parentNode.textContent);
    return '';
  }

  function chooseInputField(field) {
    if (!field || field.disabled) return false;
    if (field.checked) return true;

    field.checked = true;
    field.setAttribute('checked', 'checked');
    triggerFieldUpdate(field);
    return true;
  }

  function chooseSelectOption(selectField, nextOption) {
    if (!selectField || !nextOption || selectField.disabled) return false;

    Array.prototype.forEach.call(selectField.options || [], function(option) {
      option.selected = false;
    });

    nextOption.selected = true;
    selectField.value = nextOption.value;
    selectField.selectedIndex = nextOption.index;
    triggerFieldUpdate(selectField);
    return true;
  }

  function getVisibleSelectOptions(selectField) {
    return Array.prototype.filter.call(selectField.options || [], function(option) {
      if (!option) return false;
      if (option.disabled) return false;
      if (normalizeText(option.value) === '') return false;
      return true;
    });
  }

  function chooseAlternativeSelectOption(selectField) {
    var options = getVisibleSelectOptions(selectField);
    if (!options.length) return null;

    var preferred = options.find(function(option) {
      return isNonMachinedChoiceText(option.textContent) || isNonMachinedChoiceText(option.value);
    }) || options.find(function(option) {
      return !isMachinedChoiceText(option.textContent) && !isMachinedChoiceText(option.value);
    });

    if (!preferred) return null;

    var machinedSelected = isMachinedChoiceText(selectField.options[selectField.selectedIndex] && selectField.options[selectField.selectedIndex].textContent)
      || isMachinedChoiceText(selectField.value);

    if (machinedSelected || selectField.value !== preferred.value) {
      chooseSelectOption(selectField, preferred);
    }

    return preferred;
  }

  function updateHiddenOptionInputs(optionEl, replacementText) {
    var hiddenInputs = optionEl.querySelectorAll('input[type="hidden"]');
    hiddenInputs.forEach(function(input) {
      var inputName = normalizeText(input.name).toLowerCase();
      var isPropertyField = inputName.indexOf('properties') !== -1 || inputName.indexOf('sidewall') !== -1;
      var holdsMachinedValue = isMachinedChoiceText(input.value);

      if (!isPropertyField && !holdsMachinedValue) return;
      input.value = replacementText || '';
      triggerFieldUpdate(input);
    });
  }

  function enforceMachinedSidewallSelect(selectField, optionEl) {
    var replacement = chooseAlternativeSelectOption(selectField);
    if (!replacement) return false;

    updateHiddenOptionInputs(optionEl, normalizeText(replacement.textContent || replacement.value));
    return true;
  }

  function enforceMachinedSidewallChoices(optionEl) {
    var handled = false;

    optionEl.querySelectorAll('select').forEach(function(selectField) {
      if (handled) return;
      if (!enforceMachinedSidewallSelect(selectField, optionEl)) return;
      handled = true;
    });
    if (handled) return true;

    var choiceFields = Array.prototype.filter.call(
      optionEl.querySelectorAll('input[type="radio"], input[type="checkbox"]'),
      function(field) {
        return field.type !== 'hidden';
      }
    );

    if (!choiceFields.length) return false;

    var preferredField = choiceFields.find(function(field) {
      return isNonMachinedChoiceText(getChoiceText(field));
    }) || choiceFields.find(function(field) {
      return !isMachinedChoiceText(getChoiceText(field));
    });

    var changed = false;
    choiceFields.forEach(function(field) {
      var choiceText = getChoiceText(field);
      if (!isMachinedChoiceText(choiceText)) return;

      if (field.checked && preferredField) {
        chooseInputField(preferredField);
      }

      if (field.checked) {
        field.checked = false;
        field.removeAttribute('checked');
        triggerFieldUpdate(field);
      }

      changed = true;
    });

    if (preferredField && !preferredField.checked) {
      chooseInputField(preferredField);
      changed = true;
    }

    if (preferredField) {
      updateHiddenOptionInputs(optionEl, getChoiceText(preferredField));
    }

    return changed;
  }

  function enforceAileronTrackNonMachinedOption() {
    if (!isAileronTrackWheelPage()) return;

    document.querySelectorAll(MACHINED_SIDEWALL_OPTION_SELECTOR).forEach(function(optionEl) {
      var optionText = normalizeText(optionEl.textContent);
      if (!MACHINED_SIDEWALL_TEXT_REGEX.test(optionText)) return;

      var changed = enforceMachinedSidewallChoices(optionEl);
      if (!changed) return;

      hideOptionGroup(optionEl, 'machinedSidewallOptionHidden');
      optionEl.dataset.machinedSidewallOptionAdjusted = 'true';
    });
  }

  function hideTubelessValveOption() {
    if (!isBlockedProductPage()) return;

    document.querySelectorAll(TUBELESS_OPTION_SELECTOR).forEach(function(optionEl) {
      var optionText = normalizeText(optionEl.textContent);
      if (!TUBELESS_TEXT_REGEX.test(optionText)) return;

      hideOptionGroup(optionEl, 'tubelessOptionHidden');
    });
  }

  function enforceWholeNumbers(input) {
    if (input.dataset.wholeNumbersBound) return;
    input.dataset.wholeNumbersBound = 'true';

    input.onkeypress = null;
    input.removeAttribute('onkeypress');
    input.setAttribute('step', '1');
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('pattern', '\\d*');

    input.addEventListener('keydown', function(e) {
      if (['.', ',', 'e', 'E', '+', '-'].includes(e.key)) {
        e.preventDefault();
      }
    }, true);

    input.addEventListener('input', function() {
      var cleaned = this.value.replace(/[^\d]/g, '');
      if (cleaned !== this.value) this.value = cleaned;
    });

    input.addEventListener('blur', function() {
      if (this.value !== '') {
        this.value = String(parseInt(this.value, 10) || '');
      }
    });
  }

  function scan() {
    document.querySelectorAll('input.gpo-number').forEach(enforceWholeNumbers);
    hideTubelessValveOption();
    enforceAileronTrackNonMachinedOption();
  }

  function init() {
    scan();

    var observer = new MutationObserver(scan);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    var attempts = 0;
    var interval = setInterval(function() {
      scan();
      attempts++;
      if (attempts >= 20) clearInterval(interval);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
